module.exports = __webpack_public_path__ + "img/image-cement-device.749fc2ea.png";